/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import Loading from "../../components/Loading";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import NewQRFields from "./NewQRFields";
import { getSingleQrcode } from "services/qrcode.routes";
import { newQrcode } from "services/qrcode.routes";
import { updateQrcode } from "services/qrcode.routes";
import queryString from "utils/queryString";

export default function NewQRCode() {
    const [searchParams] = useSearchParams();
    const method = searchParams.get("method")
    const qrcodeUUID = searchParams.get("qrcodeUUID")
    const qrcodeId = searchParams.get("qrcodeId")
    const [loading, setLoading] = useState(false);
    const [submittedQR, setSubmittedQR] = useState();
    const [information, setInformation] = useState({});

    let schema = yup.object().shape({
        name: yup.string().required(),
        total: yup.number().required(),
        is_active: yup.string().required(),
        amount: yup.number(),
        ghollak_id: yup.number(),
        user_id: yup.number(),
        nfc_id: yup.string(),
    });
    useEffect(() => {
        if (method === "update" && qrcodeUUID) {
            setLoading(true);
            getSingleQrcode(qrcodeUUID, (isOk, data) => {
                if (!isOk) {
                    setLoading(false);
                    return toast.error(data.message)
                } else {
                    setLoading(false);
                    setInformation({
                        name: data.name,
                        amount: data.amount,
                        total: data.total,
                        remaining: data.remaining,
                        user_id: data.user_id,
                        ghollak_id: data.ghollak_id,
                        nfc_id: data.nfc_id,
                        is_active: +data.is_active,
                    })

                }
            })
        }
    }, [qrcodeUUID]);

    const submitQrcode = () => {
        schema.validate(information)
            .then(async (res) => {
                if (res) {
                    let qrData = {};
                    for (let item in information) {
                        if (information[item]) {
                            qrData[item] = information[item];
                        }
                    }
                    setLoading(true)


                    newQrcode(queryString(qrData), (isOk, data) => {
                        setLoading(false)
                        if (!isOk) {
                            return toast.error(data.message);
                        } else {
                            toast.success(`QR اضافه شد!`);
                            setInformation({})
                            setSubmittedQR(data)

                        }
                    });
                }
            }).catch(err => {
                return toast.error(err.errors[0])
            })
    }
    const submitUpdateQrcode = () => {
        let qrData = {};
        for (let item in information) {
            if (information[item]) {
                qrData[item] = information[item];
            }
        }
        setLoading(true)

        updateQrcode(qrcodeId, queryString(qrData), (isOk, data) => {
            setLoading(false)
            if (!isOk) {
                return toast.error(data.message);
            } else {
                toast.success(`QR آپدیت شد!`);
                setInformation({})
                setSubmittedQR(data)
            }
        });
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Loading loading={loading} />

            <NewQRFields information={information} setInformation={setInformation} setSubmittedQR={setSubmittedQR}
                submitQrcode={submitQrcode} submittedQR={submittedQR} method={method}
                submitUpdateQrcode={submitUpdateQrcode} />
        </DashboardLayout>
    )
}
